import { useTranslation } from 'react-i18next'
import './skip-link.scss'

export function SkipLink() {
  const { t } = useTranslation()

  return (
    <a href="#main-content" className="skip-link">
      {t('skip-to-content')}
    </a>
  )
};
